import React from 'react';
import PropTypes from 'prop-types';
import BehaviorIndicator from './behaviorIndicator';
import BehaviorIndicatorsGraph from './behaviorIndicatorsGraph';

const BehaviorIndicatorsBlock = props => (
  <section className={'behavior-indicators-block'}>
    {!props.removeChart && (
      <BehaviorIndicatorsGraph
        extraId={props.extraId}
        config={props.config}
        data={{ behaviorGrade: props.data.behaviorGrade, indicators: props.data.indicators }}
        graphColorRange={props.graphColorRange}
      />
    )}
    <div className="behavior-indicator-indicators-wrapper">
      {props.data.indicators &&
        props.data.indicators.map((item, i) => {
          if (props.config[item.name]) {
            return (
              <BehaviorIndicator
                key={i}
                data={item}
                config={props.config[item.name]}
                graphColorRange={props.graphColorRange}
              />
            );
          } else {
            return null;
          }
        })}
    </div>
  </section>
);

export default BehaviorIndicatorsBlock;



// WEBPACK FOOTER //
// ./source/client/components/common/behavior/behaviorIndicatorsBlock.jsx